<template>
  <div class="application-page upper-input">
    <div class="one-right">
      <h1>
        RacingMax
      </h1>
    </div>
    <div class="one-right">
      <h2>
        QBE Motor Cycle Insurance System
      </h2>
    </div>
    <div class="one-right">
      <div class="bar">
        <div class="btn-home">
          <el-button
            size="small"
            @click="$router.replace('/')"
          >
            Home
          </el-button>
          <el-button
            size="small"
            @click="backQuote">Quote</el-button>
        </div>
        <div class="step-container">
          <div class="step">
            <span class="step_n">1</span>
            <span>Quote</span>
          </div>
          <span class="line" />
          <div class="step active">
            <span class="step_n">2</span>
            <span>Policy</span>
          </div>
        </div>
      </div>
    </div>
    <el-form
      ref="form"
      :rules="rules"
      :model="formData"
      :disabled="disabledStatusForm"
    >
      <div class="bg-gray">
        <div class="one-right">
          <h3>
            Cover Note Information
          </h3>
        </div>  
        <div class="form-box">
          <div class="tr">
            <div class="left">
              Insurer
            </div>
            <div class="right">
              <v-input
                v-model="formData.insurer"
                :disabled="true"
              />
            </div>
          </div>
        
          <div class="tr">
            <div class="left">
              Business Type
            </div>
            <div class="right">
              <el-form-item
                ref="business_type"
                prop="business_type"
              >
                <v-select
                  v-model="formData.business_type"
                  :list="allOptions.business_type"
                  :disabled="true"
                />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Vehicle Usage
            </div>
            <div class="right">
              <el-form-item
                ref="usage_ind"
                prop="usage_ind"
              >
                <v-select
                  v-model="formData.usage_ind"
                  :list="allOptions.usage"
                  :disabled="true"
                />
              </el-form-item>
            </div>
          </div>
        
          <div class="tr">
            <div class="left">
              Type of Coverage
            </div>
            <div class="right">
              <v-select
                v-model="formData.trm_of_cvr"
                :list="trmOptions"
                :disabled="true"
              />
            </div>
          </div>
          <!-- <div class="tr">
            <div class="left">
              Effective Date & Time
            </div>
            <div class="right">
              <el-form-item
                ref="pcy_cmnt_dt"
                prop="pcy_cmnt_dt"
              >
                <v-datetime-picker v-model="formData.pcy_cmnt_dt" />
              </el-form-item>
            </div>
          </div> -->
        </div>
      </div>
      <div class="bg-white">
        <div class="one-right">
          <h3>Proposer Information</h3>
        </div>
        <div class="form-box">
          <div class="tr">
            <div class="left">
              Proposer Name
            </div>
            <div class="right">
              <el-form-item
                ref="isrd_nm"
                prop="isrd_nm"
              >
                <v-input
                  v-model="formData.isrd_nm"
                  maxlength="120" />
              </el-form-item>
            </div>
          </div>
          <div
            v-if="formData.cust_typ == 2"
            class="tr">
            <div class="left">
              Company BR Number
            </div>
            <div class="right">
              <el-form-item
                ref="br_no"
                prop="br_no"
              >
                <v-input
                  v-model="formData.br_no" />
              </el-form-item>
            </div>
          </div>
          <div
            v-if="formData.cust_typ == 2"
            class="tr">
            <div class="left">
              Named Driver Full Name
            </div>
            <div class="right">
              <el-form-item
                ref="nm_drvr_name_1"
                prop="nm_drvr_name_1"
              >
                <v-input
                  v-model="formData.nm_drvr_name_1" />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              HKID
            </div>
            <div class="right">
              <el-form-item
                ref="id_no"
                prop="id_no"
              >
                <v-input
                  v-model="formData.id_no"
                  maxlength="30" />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Date of Birth (DD-MM-YYYY)
            </div>
            <div class="right">
              <el-form-item
                ref="nm_drvr_dob_1"
                prop="nm_drvr_dob_1"
              >
                <v-date-picker v-model="formData.nm_drvr_dob_1" />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Mobile Number
            </div>
            <div class="right">
              <el-form-item
                ref="mobile_no"
                prop="mobile_no"
              >
                <v-input
                  v-model="formData.mobile_no"
                  maxlength="8" />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Address line 1
            </div>
            <div class="right">
              <v-input
                v-model="formData.addr_1"
                maxlength="30" />
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Address line 2
            </div>
            <div class="right">
              <v-input
                v-model="formData.addr_2"
                maxlength="30" />
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Address line 3
            </div>
            <div class="right">
              <v-input
                v-model="formData.addr_3"
                maxlength="30" />
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Address line 4
            </div>
            <div class="right">
              <v-input
                v-model="formData.addr_4"
                maxlength="30" />
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Driving License Type
            </div>
            <div class="right">
              <el-form-item
                ref="nm_drvr_exp_1"
                prop="nm_drvr_exp_1"
              >
                <v-select
                  v-model="formData.nm_drvr_exp_1"
                  disabled="disabled"
                  :list="allOptions.driver_license_type"
                />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Occupation
            </div>
            <div class="right">
              <el-form-item
                ref="nm_drvr_occ_1"
                prop="nm_drvr_occ_1"
              >
                <v-input v-model="formData.nm_drvr_occ_1" />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              NCD
            </div>
            <div class="right">
              <el-form-item
                ref="ncd_pct"
                prop="ncd_pct"
              >
                <v-select
                  v-model="formData.ncd_pct"
                  :list="allOptions.ncd"
                />
              </el-form-item>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-gray">
        <div class="one-right">
          <h3>Second Named Driver(Optional)</h3>
        </div>
        <div class="form-box">
          <div class="tr">
            <div class="left">
              Full Name
            </div>
            <div class="right">
              <el-form-item>
                <v-input
                  v-model="formData.nm_drvr_name_2" />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              HKID
            </div>
            <div class="right">
              <el-form-item>
                <v-input
                  v-model="formData.nm_drvr_id_no_2"
                  maxlength="30" />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Date of Birth (DD-MM-YYYY)
            </div>
            <div class="right">
              <el-form-item>
                <v-date-picker v-model="formData.nm_drvr_dob_2" />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Driving License Type
            </div>
            <div class="right">
              <el-form-item>
                <v-select
                  v-model="formData.nm_drvr_exp_2"
                  :list="allOptions.driver_license_type" />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Occupation
            </div>
            <div class="right">
              <el-form-item>
                <v-input
                  v-model="formData.nm_drvr_occ_2" />
              </el-form-item>
            </div>
          </div>
        </div>
      </div>


      <div class="bg-white">
        <div class="one-right">
          <h3>Vehicle Information</h3>
        </div>
        <div class="form-box">
          <div class="tr">
            <div class="left">
              Registration Number
            </div>
            <div class="right">
              <el-form-item
                ref="rgtn_no"
                prop="rgtn_no"
              >
                <v-input
                  v-model="formData.rgtn_no"
                  maxlength="16" />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Body Type
            </div>
            <div class="right">
              <el-form-item
                ref="typ_of_bdy_id"
                prop="typ_of_bdy_id"
              >
                <v-select
                  v-model="formData.typ_of_bdy_id"
                  :list="allOptions.body_type"
                />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Make
            </div>
            <div class="right">
              <el-form-item
                ref="brand"
                prop="brand"
              >
                <v-autocomplete
                  v-model="formData.brand"
                  :list="allOptions.make"
                  @select="handlerSelectBrand" />
                <!-- <v-select
                  v-model="formData.brand_id"
                  :list="allOptions.make"
                /> -->
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Model
            </div>
            <div class="right">
              <el-form-item
                ref="rgtn_mdl"
                prop="rgtn_mdl"
              >
                <v-input v-model="formData.rgtn_mdl" />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Cubic Capacity
            </div>
            <div class="right">
              <el-form-item
                ref="engn_cpcty"
                prop="engn_cpcty"
              >
                <v-input v-model="formData.engn_cpcty" />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Year of Manufacturing
            </div>
            <div class="right">
              <el-form-item
                ref="rgtn_yr"
                prop="rgtn_yr"
              >
                <v-input v-model="formData.rgtn_yr" />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Engine Number
            </div>
            <div class="right">
              <el-form-item
                ref="engn_no"
                prop="engn_no"
              >
                <v-input
                  v-model="formData.engn_no"
                  maxlength="24" />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Chassis Number
            </div>
            <div class="right">
              <el-form-item
                ref="chasis_no"
                prop="chasis_no"
              >
                <v-input
                  v-model="formData.chasis_no"
                  maxlength="20" />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Seating Capacity
            </div>
            <div class="right">
              <el-form-item
                ref="no_of_seats"
                prop="no_of_seats"
              >
                <v-input
                  v-model="formData.no_of_seats"
                  maxlength="2"
                  type="number"
                />
              </el-form-item>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-gray">
        <div class="form-box">
          <div class="tr">
            <div class="left">
              Remarks
            </div>
            <div class="right">
              <v-input
                v-model="formData.remarks"
                placeholder="PLEASE ENTER AND NO MORE THAN 80 CHARACTERS"
                maxlength="80"
                type="textarea"
                :rows="Number(4)"
              />
            </div>
          </div>
          <div class="one-right">
            <div class="mg-b-15">
              <el-button
                type="primary"
                @click="handleNext(1)"
              >
                Issue Cover Note
              </el-button>
              <el-button
                type="primary"
                @click="handleNext(2)"
              >
                Refresh
              </el-button>
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Issue Date & Time
            </div>
            <div class="right">
              <v-datetime-picker
                v-model="formData.issue_dt"
                :disabled="true"
              />
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Cover Note Number
            </div>
            <div class="right">
              <v-input
                v-model="formData.cvr_nt_no"
                :disabled="true"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="bg-white">
        <div class="form-box">
          <div class="tr">
            <div class="left">
              Policy Number
            </div>
            <div class="right">
              <v-input
                v-model="formData.pcy_no"
                :disabled="true"
              />
            </div>
          </div>
          <div class="tr">
            <div class="left">
              Issue Date & Time
            </div>
            <div class="right">
              <v-datetime-picker
                v-model="formData.pcy_issue_dt"
                :disabled="true"
              />
            </div>
          </div>
        </div>
        <div class="one-right">
          <el-button
            type="warning"
            :disabled="disabledStatusIssuePolicyBtn"
            @click="handleNext(3)"
          >
            Issue Policy
          </el-button>
          <el-button
            type="warning"
            :disabled="disabledStatusIssuePolicyBtn"
            @click="handleNext(4)"
          >
            Refresh
          </el-button>
        </div>
      </div>
    </el-form>
    <el-form
      ref="status-form"
      :model="formData"
      :rules="statusRules">
      <div class="bg-gray">
        <div class="form-box">
          <div class="tr">
            <div class="left">Locked</div>
            <div class="right">
              <el-form-item
                prop="lock"
              >
                <v-select
                  v-model="formData.lock"
                  :disabled="disabledLockedOpt"
                  :list="lockedOptions" />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">Record Status</div>
            <div class="right">
              <el-form-item
                prop="status"
              >
                <v-select
                  v-model="formData.status"
                  :list="recordStatusOptions" />
              </el-form-item>
            </div>
          </div>
          <div class="tr">
            <div class="left">Internal Remarks</div>
            <div class="right">
              <v-input
                v-model="formData.internal_remarks"
                type="textarea"
                :rows="4" />
            </div>
          </div>
          <div class="tr">
            <div class="left"></div>
            <div class="right">
              <el-button
                :disabled="disabledStatusSaveBtn"
                type="danger"
                @click="handlerSaveStatus">
                <i class="el-icon-finished"></i> Save
              </el-button>
              <el-button
                :disabled="disabledStatusCoverNoteBtn"
                type="success"
                @click="handlerDownload(1)">
                <i class="el-icon-download"></i> Cover Note
              </el-button>
              <el-button
                :disabled="disabledStatusPolicyBtn"
                type="success"
                @click="handlerDownload(3)">
                <i class="el-icon-download"></i> Policy
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    

    <el-button
      v-if="dev"
      type="danger"
      size="mini"
      class="btn-text"
      @click="handleText"
    >
      數據填充
    </el-button>
  </div>
</template>
<script>
import { deepToUpperCase } from '@/jslib/upperCase.js'
import { downloadPdf, openFile } from '@/jslib/file'
import { mapState, mapActions } from 'vuex'
import { createPolicy, updatePolicy, downloadPolicy, getPolicyData, setPolicyStatus } from '@/api'
import options from '@/mixins/options'
export default {
  name: 'Application',
  mixins: [options],
  data() {
    const checkEngnCpcty = (rules, value, callback) => {
      if(value.length > 4) {
        callback(new Error('請填寫小於 4 位的正整數'))
      }
      callback()
    }
    const checkYear = (rule, value, callback) => {
      const reg = /19[0-9]{2}|20[0-9]{2}/
      const y = new Date().getFullYear()
      if (!reg.test(value) || value > y) {
        callback(new Error('請輸入正確的年份'))
      }
      callback()
    }
    const checkRequire = (rules, value, callback) => {
      if(this.type > 2 && !value) {
        callback(new Error('Please Enter'))
      }
      callback()
    }
    const checkSeat = (rules, value, callback) => {
      if(value.length > 2) {
        callback(new Error('最多兩位數'))
      }
      callback()
    }
    const checkName = (rules, value, callback) => {
      const reg = /^[\x20-\x7E]*$/
      if(!reg.test(value)) {
        callback(new Error('請輸入英文字符'))
      }
      callback()
    }
    return {
      type: '',
      //   policyId: '',
      selectBrand: {},
      formData: {
        insurer: 'QBE',
        issue_dt: '',
        pcy_issue_dt: '',
        business_type: '',
        usage_ind: '',
        cvr_nt_no: '',
        trm_of_cvr: '1',
        // pcy_cmnt_dt: '',
        isrd_nm: '',
        id_no: '',
        nm_drvr_dob_1: '',
        mobile_no: '',
        addr_1: '',
        addr_2: '',
        addr_3: '',
        addr_4: '',
        isrd_exp: '',
        occ: '',
        ncd_pct: '',
        rgtn_no: '',
        typ_of_bdy_id: '',
        brand_id: '',
        rgtn_mdl: '',
        engn_cpcty: '',
        rgtn_yr: '',
        engn_no: '',
        chasis_no: '',
        no_of_seats: '',
        remarks: '',
        pcy_no: '',
        nm_drvr_name_1: '',
        nm_drvr_occ_1: '',
        nm_drvr_exp_1: '',
        nm_drvr_name_2: '',
        nm_drvr_id_no_2: '',
        nm_drvr_dob_2: '',
        nm_drvr_exp_2: '',
        nm_drvr_occ_2: '',
        // issue_dt: ''
        brand: '',
        cvr_nt_path: '',
        pcy_path: '',
        lock: 0,
        status: 1,
        internal_remarks: ''
      },
      super_admin: false,
      rules: {
        // pcy_cmnt_dt: [
        //   { required: true, message: 'Please Select', trigger: ['change', 'blur'] }
        // ],
        isrd_nm: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] },
          { validator: checkName, trigger: ['change', 'blur'] }
        ],
        business_type: [
          { required: true, message: 'Please Select', trigger: ['change', 'blur'] }
        ],
        usage_ind: [
          { required: true, message: 'Please Select', trigger: ['change', 'blur'] }
        ],
        typ_of_bdy_id: [
          { required: true, message: 'Please Select', trigger: ['change', 'blur'] }
        ],
        engn_cpcty: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] },
          { validator: checkEngnCpcty, trigger: ['change', 'blur'] }
        ],
        rgtn_yr: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] },
          { validator: checkYear, trigger: ['change', 'blur'] }
        ],
        nm_drvr_exp_1: [
          { required: true, message: 'Please Select', trigger: ['change', 'blur'] }
        ],
        nm_drvr_occ_1: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] }
        ],
        nm_drvr_dob_1: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] }
        ],
        nm_drvr_name_1: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] }
        ],
        ncd_pct: [
          { required: true, message: 'Please Select', trigger: ['change', 'blur'] }
        ],
        brand: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] }
        ],
        rgtn_mdl: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] }
        ],
        engn_no: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] }
        ],
        chasis_no: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] }
        ],
        no_of_seats: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] },
          { validator: checkSeat, trigger: ['change', 'blur'] }
        ],
        br_no: [
          { required: true, message: 'Please Enter', trigger: ['change', 'blur'] }
        ],
        // 
        id_no: [
          { validator: checkRequire, trigger: ['change', 'blur'] }
        ],
        mobile_no: [
          { validator: checkRequire, trigger: ['change', 'blur'] }
        ],
        rgtn_no: [
          { validator: checkRequire, trigger: ['change', 'blur'] }
        ],
        
      },
      recordStatusOptions: [
        {
          name: 'Active',
          id: 1
        },
        {
          name: 'Void',
          id: 0
        }
      ],
      lockedOptions: [
        {
          name: 'Yes',
          id: 1
        },
        {
          name: 'No',
          id: 0
        }
      ],
      // statusFormData: {
      //   status: '',
      //   internal_remarks: ''
      // },
      statusRules: {
        status: [
          { required: true, message: 'Please Select', trigger: ['change', 'blur'] }
        ],
      }
    }
  },
  computed: {
    ...mapState('policy', ['policyForm', 'policyId']),
    dev() {
      return process.env.NODE_ENV === 'development'
    },
    disabledStatusForm() {
      return !this.super_admin && Boolean(this.formData.lock)
    },
    disabledLockedOpt() {
      return !this.super_admin
    },
    disabledStatusSaveBtn() {
      return !this.policyId && !this.$route.query.policyId
    },
    disabledStatusCoverNoteBtn() {
      return !this.formData.cvr_nt_path
    },
    disabledStatusPolicyBtn() {
      return !this.formData.pcy_path
    },
    disabledStatusIssuePolicyBtn() {
      //改單不允許出正式保單
      return this.formData.business_type.toString() === '30'
    }
  },
  created() {
    let userinfo = JSON.parse(localStorage.getItem('userinfo'))
    this.super_admin = userinfo && userinfo.super_admin
    this.updateAllOptions()
    const { policyId = '' } = this.$route.query
    if(policyId) {
      // this.setPolicyId(policyId)
      if(!this.policyId) {
        this.network().getPolicyData(policyId)
      }
    }
    // if(this.policyId) {
    //   this.network().getPolicyData(this.policyId)
    // }
    this.formData = Object.assign(this.formData, this.policyForm)
    // this.formData.brand = this.formData.brand
  },
  methods: {
    ...mapActions('main', ['updateAllOptions']),
    ...mapActions('policy', ['setPolicyId', 'setPolicyForm']),
    handleText() {
      Object.assign(this.formData, {
        // issue_dt: '21-02-2020 20:00',
        // business_type: '20',
        // usage_ind: '0',
        // cvr_nt_no: '123456',
        // trm_of_cvr: '5',
        // pcy_no: '123456',

        // pcy_cmnt_dt: '21-02-2020 19:20',
        isrd_nm: 'APeng',
        id_no: 'A1234563',
        // nm_drvr_dob_1: '01-01-1990',
        mobile_no: '123456',
        addr_1: 'Kowloon',
        addr_2: 'Tsim Sha Tsui',
        addr_3: '100 Nathan Road',
        addr_4: '13/F',
        isrd_exp: '5',
        occ: 'Worker',
        ncd_pct: '10',
        rgtn_no: '123456',
        typ_of_bdy_id: '20',
        brand_id: '9',
        rgtn_mdl: '20',
        engn_cpcty: '125',
        // rgtn_yr: '2015',
        engn_no: 'EN028490283490',
        chasis_no: 'CN0002342343',
        no_of_seats: '2',
        remarks: 'This is remarks',
      })
    },
    handlerSelectBrand(item) {
      this.selectBrand = item
      this.formData.brand_id = item.id
    },
    backQuote() {
      if(!this.policyId && this.$route.query.policyId) {
        this.setPolicyId(this.$route.query.policyId)
      }
      this.setPolicyForm(this.formData) // 緩存頁面數據
      this.$router.replace('/quotation')
    },
    nextSubmit(type) {
      // 1: Issue Cover Note;
      // 2: Re-Issue Cover Note;
      // 3: Issue Policy;
      // 4:Re-Issue Policy
      this.setPolicyForm(this.formData) // 緩存表單數據
      // 處理 brand 和 brand_id
      // const { id, name } = this.selectBrand
      // if(id && name !== this.formData.brand) {
      //   this.formData.brand_id = 0
      // }
      if(!this.policyId && this.$route.query.policyId) {
        this.setPolicyId(this.$route.query.policyId)
      }
      const { brand } = this.formData
      // getAllOptionsName
      const id = this.getAllOptionsId('make', brand)
      this.formData.brand_id = id? id: 0
      if(this.policyId) {
        this.network().updatePolicy(type)
      } else {
        this.network().createPolicy(type)
      }
    },
    handleNext(type) {
      this.type = type
      this.$refs['form'].validate((valid, options) => {
        if(valid) {
          let is_pcy_type = type === 3 || type === 4
          let unusual_rgtn_no = new Set(['TBA', 'TBC', 'T.B.A', 'T.B.C', 'T.B.A.', 'T.B.C.', ''])
          if(is_pcy_type && unusual_rgtn_no.has(this.formData.rgtn_no.trim())){
            this.$confirm('請確認當前車牌號碼【' + this.formData.rgtn_no + '】是否正確？', '提示', {
              confirmButtonText: '確認',
              cancelButtonText: '我再睇睇',
              type: 'warning'
            }).then(() => {
              this.nextSubmit(type)
            }).catch(() => {
              return false
            })
          }else{
            this.nextSubmit(type)
          }
        } else {
          Object.keys(options).some(key => {
            const dom = this.$refs[key]
            const top = dom.$el.offsetTop 
            document.getElementById('scroll-content').scrollTop = top - 50
            return true
          })
        }
      })
    },
    handlerSaveStatus() {
      this.$refs['status-form'].validate((valid) => {
        if(valid) {
          const policyId = this.policyId || this.$route.query.policyId
          let param = {
            policy_id: policyId,
            status: Number(this.formData.status),
            internal_remarks: this.formData.internal_remarks
          }
          if(this.super_admin) param['lock'] = this.formData.lock
          this.network().setPolicyStatus(param)
        }
      })
    },

    handlerDownload(type) {
      let path = ''
      if(type === 1){
        path = this.formData.cvr_nt_path
      }else if(type === 3){
        path = this.formData.pcy_path
      }
      path && this.network().downloadPolicy(path)
    },

    handler() {
      return {
        handlerResult: (type, data) => {
          // 1: Issue Cover Note;
          // 2: Re-Issue Cover Note; 
          // 3: Issue Policy; 
          // 4:Re-Issue Policy
          // 1 3 下載， 2 4 刷新
          const { cvr_nt_no, issue_dt, pcy_no, url, pcy_issue_dt } = data.data
          this.formData = Object.assign(this.formData, {
            cvr_nt_no,
            issue_dt,
            pcy_no,
            pcy_issue_dt
          })
          if(type === 1 || type === 2){
            this.formData.cvr_nt_path = data.data.path
          }else if(type === 3 || type === 4){
            this.formData.pcy_path = data.data.path
          }
          if(type === 1 || type === 3) {
            // this.network().downloadPolicy(data.data.path)
            // setTimeout(() => {
            openFile(url) // 直接拿接口返回的 url
            // }, 5000)
          } else {
            this.$message({
              type: 'success',
              message: 'SUCCESS'
            })
          }
        }
      }
    },
    network() {
      return {
        getPolicyData: async policyId => {
          let { data } = await getPolicyData(policyId)
          this.formData = Object.assign(this.formData, data.data)
          // this.setPolicyForm(this.formData) // 緩存表單數據 
          // this.setPolicyId(policyId)
        },
        createPolicy: async (type) => {
          let params = deepToUpperCase(this.formData)
          const { data } = await createPolicy({
            ...params,
            type
          })
          if(!data.code) {
            this.setPolicyId(data.data.pcy_id)
            this.handler().handlerResult(type, data)
          }
        },
        updatePolicy: async (type) => {
          let params = deepToUpperCase(this.formData)
          // const policyId = this.policyId || this.$route.query.policyId
          const { data } = await updatePolicy(this.policyId, {
            ...params,
            type
          })
          if(!data.code) {
            this.handler().handlerResult(type, data)
          }
        },
        downloadPolicy: async path => {
          const { data, headers } = await downloadPolicy({
            path
          })
          downloadPdf(data, headers)
        },
        setPolicyStatus: async (params) => {
          const { data } = await setPolicyStatus(params)
          this.$message({
            type: 'success',
            message: 'SUCCESS'
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.application-page {
  text-align: center;
  color: #303133;
  .mg-b-15 {
    margin-bottom: 15px;
  } 
  h1 {
    font-size: 32px;
  }
  h2 {
    margin-bottom: 20px;
    font-size: 24px;
  }
  h3 {
      margin-bottom: 15px;
      font-size: 16px;
  }
  .one-right {
      margin: 0 auto;
      padding-left: 240px;
      width: 740px;
      text-align: left;
  }
  .bar {
      display: flex;
      align-items: center;
      padding: 15px 0;
      .btn-home {
          margin-right: 100px;
      }
  }
  .step-container {
    display: flex;
    .line {
        display: block;
        margin-top: 12px;
        margin-left: -11px;
        margin-right: -10px;
        width: 160px;
        height: 2px;
        background: #DDDFE7;
    }
    .step {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      font-size: 16px;
      font-weight: bold;
      color: #DDDFE7;
      &.active {
          color: #303133;
          .step_n {
              border: 2px solid #303133;
          }
      }
      .step_n {
        display: block;
        margin-bottom: 7px;
        width: 24px;
        height: 24px;
        line-height: 18.5px;
        border: 2px solid #DDDFE7;
        border-radius: 100%;
        text-align: center;
      }
    }
  }
  .left {
    width: 230px;
    text-align: right;
    color: #616266;
    font-size: 16px;
  }
  .right {
    margin-left: 10px;
    width: 500px;
    text-align: left;
  }
  .tr {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
  }
  .bg-gray {
    padding: 20px 0;
    background: #f8f8f8;
    &:last-child {
        padding-bottom: 50px;
    }
  }
  .bg-white {
    padding: 20px 0;
    background: white;
  }
  .btn-container {
      margin: 30px auto 50px auto;
  }
}
</style>